import { useMemo } from 'react';
import { useForm, Mode } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { createFinanceFieldsSchema } from 'typescript/schemas/finance_forms/finance_fields';
import { CountryCode } from 'typescript/constants/localization';

interface useFinanceFormProps {
  countryCode: CountryCode;
  validationMode?: Mode;
}

const useFinanceForm = ({
  countryCode,
  validationMode = 'onBlur',
}: useFinanceFormProps) => {
  const financeFieldsSchema = useMemo(() => {
    return createFinanceFieldsSchema({ countryCode });
  }, []);

  const formMethods = useForm({
    mode: validationMode,
    resolver: zodResolver(financeFieldsSchema),
  });

  return {
    financeFieldsSchema,
    formMethods,
  };
};

export default useFinanceForm;
